module.exports = __webpack_public_path__ + "sgby/img/diaochan-pic.b624ed4.png";